// next-font 中 variable 必需使用字面量，
// 因此此处也仅是使用字面量方便在 gen-antd-css 中使用而已
// 这里需要和 next-font.ts 中 字体的 variable 值 对应上
export const variableOpenSans = '--open-sans-font'

// export const variablePoppinsFont = '--poppins-font'

// export const variableInterFont = '--inter-font'
